import React from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { FormViewDecorator } from 'site-modules/shared/components/lead-form/unified-lead-form/views/form-view-decorator';

import './inventory-empty-view.scss';

function InventoryEmptyViewUI() {
  return (
    <Row className="inventory-empty-view pos-r">
      <Col xs={12} md={7} className="module d-flex flex-column bg-white p-1 p-md-1_5 rounded-12">
        <div className="heading-3 mb-2 text-blue-50">Save with Edmunds</div>
        <div className="heading-4 mb-1">Sorry!</div>
        <div className="mb-1">You are outside our supported search radius.</div>
      </Col>
    </Row>
  );
}

export const InventoryEmptyView = FormViewDecorator(InventoryEmptyViewUI);
